import { Tickets } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer, resetReducer,
    getAction, listAction, updateAction, duplicateAction, linkedResourcesAction,
    startCreateAction, createAction, deleteAction, linkedResourcesReducer, resetAction
} = createRestSlices(Tickets);

initialState.filters                     = { 'status': 'activated' };
initialState.isImporting                 = false;
initialState.hasImportingError           = false;
initialState.importingErrorMessage       = '';
initialState.isPreviewingTickets         = false;
initialState.hasPreviewingError          = false;
initialState.previewingErrorMessage      = '';
initialState.ticketsImportPreview          = null;
initialState.updatedWallets              = null;
initialState.isUpdatingWallets           = false;
initialState.hasUpdatingWalletsError     = false;
initialState.updatingWalletsErrorMessage = '';
initialState.updatedArticles             = null;
initialState.isUpdatingArticles          = false;
initialState.hasUpdatingArticlesError    = false;
initialState.updatingArticlesErrorMessage = '';
initialState.pdfUrls                     = [];
initialState.isLoadingPdfUrls            = false;
initialState.hasLoadingPdfUrlsError      = false;
initialState.loadingPdfUrlsErrorMessage  = '';

const IMPORTING_TICKETS         = 'kronos/tickets/IMPORTING_TICKETS';
const IMPORTING_TICKETS_SUCCESS = 'kronos/tickets/IMPORTING_TICKETS_SUCCESS';
const IMPORTING_TICKETS_FAILURE = 'kronos/tickets/IMPORTING_TICKETS_FAILURE';
const PREVIEWING_TICKETS         = 'kronos/tickets/PREVIEWING_TICKETS';
const PREVIEWING_TICKETS_SUCCESS = 'kronos/tickets/PREVIEWING_TICKETS_SUCCESS';
const PREVIEWING_TICKETS_FAILURE = 'kronos/tickets/PREVIEWING_TICKETS_FAILURE';
const CLEAR_TICKETS_IMPORT_PREVIEW = 'kronos/tickets/CLEAR_TICKETS_IMPORT_PREVIEW';
const RESET_WALLETS_UPDATE      = 'kronos/tickets/RESET_WALLETS_UPDATE';
const UPDATING_WALLETS          = 'kronos/tickets/UPDATING_WALLETS';
const UPDATING_WALLETS_SUCCESS  = 'kronos/tickets/UPDATING_WALLETS_SUCCESS';
const UPDATING_WALLETS_FAILURE  = 'kronos/tickets/UPDATING_WALLETS_FAILURE';
const RESET_ARTICLES_UPDATE     = 'kronos/tickets/RESET_ARTICLES_UPDATE';
const UPDATING_ARTICLES         = 'kronos/tickets/UPDATING_ARTICLES';
const UPDATING_ARTICLES_SUCCESS = 'kronos/tickets/UPDATING_ARTICLES_SUCCESS';
const UPDATING_ARTICLES_FAILURE = 'kronos/tickets/UPDATING_ARTICLES_FAILURE';
const UPDATING_FILTERS          = 'kronos/tickets/UPDATING_FILTERS';
const LOADING_PDF_URLS          = 'kronos/tickets/LOADING_PDF_URLS';
const LOADING_PDF_URLS_SUCCESS  = 'kronos/tickets/LOADING_PDF_URLS_SUCCESS';
const LOADING_PDF_URLS_FAILURE  = 'kronos/tickets/LOADING_PDF_URLS_FAILURE';

const reducer = (state, action) => {
    switch (action.type) {
        case IMPORTING_TICKETS:
            return {
                ...state,
                isImporting: true,
                hasImportingError: false,
                importingErrorMessage: ''
            };
        case IMPORTING_TICKETS_SUCCESS:
            return {
                ...state,
                isImporting: false,
                hasImportingError: false,
                importingErrorMessage: '',
                imported: action.imported
            };
        case IMPORTING_TICKETS_FAILURE:
            return {
                ...state,
                isImporting: false,
                hasImportingError: true,
                importingErrorMessage: action.error.message
            };
        case PREVIEWING_TICKETS:
            return {
                ...state,
                isPreviewingTickets: true,
                hasPreviewingError: false,
                previewingErrorMessage: '',
                hasImportingError: false,
                importingErrorMessage: ''
            };
        case PREVIEWING_TICKETS_SUCCESS:
            return {
                ...state,
                isPreviewingTickets: false,
                hasPreviewingError: false,
                previewingErrorMessage: '',
                ticketsImportPreview: action.preview
            };
        case PREVIEWING_TICKETS_FAILURE:
            return {
                ...state,
                isPreviewingTickets: false,
                hasPreviewingError: true,
                previewingErrorMessage: action.error.message
            };
        case CLEAR_TICKETS_IMPORT_PREVIEW:
            return {
                ...state,
                ticketsImportPreview: null,
                hasPreviewingError: false,
                previewingErrorMessage: '',
                hasImportingError: false,
                importingErrorMessage: ''
            };
        case RESET_WALLETS_UPDATE:
            return {
                ...state,
                updatedWallets: null,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: false,
                updatingWalletsErrorMessage: ''
            };
        case UPDATING_WALLETS:
            return {
                ...state,
                isUpdatingWallets: true,
                hasUpdatingWalletsError: false
            };
        case UPDATING_WALLETS_SUCCESS:
            return {
                ...state,
                updatedWallets: action.updatedWallets,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: false,
                imported: action.imported
            };
        case UPDATING_WALLETS_FAILURE:
            return {
                ...state,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: true,
                updatingWalletsErrorMessage: action.error.message
            };
        case RESET_ARTICLES_UPDATE:
            return {
                ...state,
                updatedArticles: null,
                isUpdatingArticles: false,
                hasUpdatingArticlesError: false,
                updatingArticlesErrorMessage: ''
            };
        case UPDATING_ARTICLES:
            return {
                ...state,
                isUpdatingArticles: true,
                hasUpdatingArticlesError: false
            };
        case UPDATING_ARTICLES_SUCCESS:
            return {
                ...state,
                updatedArticles: action.updatedArticles,
                isUpdatingArticles: false,
                hasUpdatingArticlesError: false
            };
        case UPDATING_ARTICLES_FAILURE:
            return {
                ...state,
                isUpdatingArticles: false,
                hasUpdatingArticlesError: true,
                updatingArticlesErrorMessage: action.error.message
            };
        case UPDATING_FILTERS:
            return {
                ...state,
                filters: action.filters,
            };
        case LOADING_PDF_URLS:
            return {
                ...state,
                isLoadingPdfUrls: true,
                hasLoadingPdfUrlsError: false,
                loadingPdfUrlsErrorMessage: ''
            };
        case LOADING_PDF_URLS_SUCCESS:
            return {
                ...state,
                pdfUrls: action.pdfUrls || [],
                isLoadingPdfUrls: false,
                hasLoadingPdfUrlsError: false,
                loadingPdfUrlsErrorMessage: ''
            };
        case LOADING_PDF_URLS_FAILURE:
            return {
                ...state,
                isLoadingPdfUrls: false,
                hasLoadingPdfUrlsError: true,
                loadingPdfUrlsErrorMessage: action.error.message
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer, resetReducer,
        linkedResourcesReducer, reducer
    ]);
}

/* Export CRUD actions */
export const startCreateTicket         = startCreateAction;
export const createTicket              = createAction;
export const loadTicket                = getAction;
export const resetTickets              = resetAction;
export const loadTickets               = listAction;
export const updateTicket              = updateAction;
export const deleteTicket              = deleteAction;
export const duplicateTicket           = duplicateAction;
export const getTicketsLinkedResources = linkedResourcesAction;

export function updateTicketsFilters(filters) {
    return (dispatch) => {
        dispatch({ type: UPDATING_FILTERS, filters });
    }
}

function importingTickets() { return { type: IMPORTING_TICKETS } }
function importingTicketsSuccess(imported) { return { type: IMPORTING_TICKETS_SUCCESS, imported: imported } }
function importingTicketsFailure(err) { return { type: IMPORTING_TICKETS_FAILURE, error: err } }
export function clearTicketsImportPreview() {
    return (dispatch) => dispatch({ type: CLEAR_TICKETS_IMPORT_PREVIEW });
}
export function previewTickets(source = null) {
    return (dispatch) => {
        dispatch({ type: PREVIEWING_TICKETS });
        Tickets.previewTickets(source)
            .then(preview => dispatch({ type: PREVIEWING_TICKETS_SUCCESS, preview }))
            .catch(err => dispatch({ type: PREVIEWING_TICKETS_FAILURE, error: err }));
    };
}
export function importTickets(data, options = null) {
    return (dispatch) => {
        dispatch(importingTickets());
        Tickets.importTickets(data, options)
            .then(data => {
                const imported = data.imported;
                dispatch(importingTicketsSuccess(imported));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(importingTicketsFailure(err))
            });
    }
}

function updatingWallets() { return { type: UPDATING_WALLETS } }
function updatingWalletsSuccess(updatedWallets) { return { type: UPDATING_WALLETS_SUCCESS, updatedWallets } }
function updatingWalletsFailure(err) { return { type: UPDATING_WALLETS_FAILURE, error: err } }
export function resetWalletsUpdate() {
    return (dispatch) => dispatch({ type: RESET_WALLETS_UPDATE });
}
export function updateWallets(ids, mode, amount) {
    return (dispatch) => {
        dispatch(updatingWallets());
        Tickets.updateWallets(ids, mode, amount)
            .then(data => {
                const updatedWallets = data.wallets;
                dispatch(updatingWalletsSuccess(updatedWallets));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(updatingWalletsFailure(err))
            });
    }
}

function updatingArticles() { return { type: UPDATING_ARTICLES } }
function updatingArticlesSuccess(updatedArticles) { return { type: UPDATING_ARTICLES_SUCCESS, updatedArticles } }
function updatingArticlesFailure(err) { return { type: UPDATING_ARTICLES_FAILURE, error: err } }
export function resetArticlesUpdate() {
    return (dispatch) => dispatch({ type: RESET_ARTICLES_UPDATE });
}
export function updateArticles(ids, mode, articleId, variantId, quantity) {
    return (dispatch) => {
        dispatch(updatingArticles());
        Tickets.updateArticles(ids, mode, articleId, variantId, quantity)
            .then(data => {
                dispatch(updatingArticlesSuccess(data.articles));
            })
            .catch(err => {
                dispatch(updatingArticlesFailure(err));
            });
    }
}

function loadingPdfUrls() { return { type: LOADING_PDF_URLS } }
function loadingPdfUrlsSuccess(pdfUrls) { return { type: LOADING_PDF_URLS_SUCCESS, pdfUrls } }
function loadingPdfUrlsFailure(err) { return { type: LOADING_PDF_URLS_FAILURE, error: err } }
export function getTicketsPdfUrls(ids, layout = 'paper', salepointId = null, options = {}) {
    return (dispatch) => {
        dispatch(loadingPdfUrls());
        return Tickets.getPdfUrls(ids, layout, salepointId, options)
            .then(data => {
                const pdfUrls = data.pdf_urls || [];
                const zipUrls = data.zip_urls || [];
                dispatch(loadingPdfUrlsSuccess(pdfUrls.length ? pdfUrls : zipUrls));
                return data;
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingPdfUrlsFailure(err));
                throw err;
            });
    }
}
